import EcoSpace from 'eco-design/base/eco-space';
import PathToZero from '../../components/PathToZero';
import BannerA from '../../components/BannerA';
import FooterTcA from '../../components/FooterTcA';
import PowerPlantSectionA from '../../components/PowerPlantSectionA';
import SubscribeWinUltraA from '../../components/SubscribeWinUltraA2';
import OnlineStoreRightsA from '../../components/OnlineStoreRightsA2';
import PowerOceanA from '../../components/PowerOceanA';
import ProductList from '../../components/ProductList';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <div className="product-box">
                <EcoSpace hPc="160px" hH5="100px" />
                <SubscribeWinUltraA />
                <EcoSpace hPc="160px" hH5="100px" />
                <OnlineStoreRightsA />
                <ProductList />
                <EcoSpace hPc="160px" hH5="0px" />
                <PathToZero />
                <EcoSpace hPc="160px" />
                <PowerPlantSectionA />
                <EcoSpace hPc="160px" />
                <PowerOceanA />
                <EcoSpace hPc="160px" hH5="0px" />
                <FooterTcA />
            </div>
        </>
    );
}
